(function () {
  if (window._skRewardsInit) return;
  window._skRewardsInit = true;

  // ---------------------------------------------------------------------
  // Central reward configuration — single source of truth (thresholds in
  // eurocents). Nothing outside this file computes thresholds/positions.
  // ---------------------------------------------------------------------
  var REWARDS = [
    { id: 'shipping', tier: null,    threshold: 3500,  variantId: null,           label: 'GRATIS verzending',                shortLabel: 'GRATIS<br>VERZENDING', value: null, icon: '🚚' },
    { id: 'spf',      tier: 'spf',    threshold: 4500,  variantId: 58590537941336, label: 'GRATIS SPF Beschermende Dagcrème', shortLabel: 'GRATIS<br>SPF',         value: 1695, icon: '☀️' },
    { id: 'bag',      tier: 'bag',    threshold: 7500,  variantId: 57497224708440, label: 'GRATIS Premium Make-up Bag',       shortLabel: 'GRATIS<br>MAKE-UP BAG', value: 2995, icon: '👜' },
    { id: 'roller',   tier: 'roller', threshold: 10000, variantId: 58590538105176, label: 'GRATIS 3D Gezichtsroller',         shortLabel: 'GRATIS<br>ROLLER',      value: 1895, icon: '✨' }
  ];

  // Gifts retired from the permanent ladder (Haarband, Hyaluronzuur Serum).
  // Never auto-added anymore, but an existing/test cart may still hold one
  // from before this change — sync() below removes those on sight.
  var DEPRECATED_GIFT_VARIANT_IDS = [58590537908568, 57497224741208];

  var MAX_THRESHOLD = REWARDS[REWARDS.length - 1].threshold;
  var GIFT_VARIANT_IDS = REWARDS.filter(function (r) { return r.variantId; })
    .map(function (r) { return r.variantId; })
    .concat(DEPRECATED_GIFT_VARIANT_IDS);

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function moneyRound(cents) {
    return money(cents).replace(',00', '');
  }

  // ---------------------------------------------------------------------
  // Serialized queue: every sync() call waits for the previous one to
  // finish. This guarantees exactly one sync runs at a time, so two
  // near-simultaneous triggers (e.g. rapid quantity clicks) can never
  // race each other into adding the same gift twice.
  // ---------------------------------------------------------------------
  var queue = Promise.resolve();
  var debounceTimer = null;
  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      queue = queue.then(sync).catch(function (err) { console.error('[SK Rewards]', err); });
    }, 250);
  }

  async function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function qualifyingValue(cart) {
    return cart.items
      .filter(function (i) { return GIFT_VARIANT_IDS.indexOf(Number(i.variant_id)) === -1; })
      .reduce(function (sum, i) { return sum + i.final_line_price; }, 0);
  }

  function findGiftLine(cart, variantId) {
    return cart.items.find(function (i) { return Number(i.variant_id) === variantId; });
  }

  function addGift(reward) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: reward.variantId,
        quantity: 1,
        properties: { _reward_tier: reward.tier }
      })
    });
  }

  // Uses the exact cart line key (variantId:propertiesHash) when available
  // so we only ever touch the specific gift line, never a coincidentally
  // identical variant added a different way.
  function setLineQuantity(line, variantId, quantity) {
    var id = line ? line.key : String(variantId);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity })
    });
  }

  async function sync() {
    var cart = await getCart();
    var qualifying = qualifyingValue(cart);
    var changed = false;

    for (var i = 0; i < REWARDS.length; i++) {
      var reward = REWARDS[i];
      if (!reward.variantId) continue; // free-shipping tier has no cart line

      var line = findGiftLine(cart, reward.variantId);
      var qualifies = qualifying >= reward.threshold;

      if (qualifies && !line) {
        await addGift(reward);
        cart = await getCart(); // refresh before evaluating the next reward
        changed = true;
      } else if (!qualifies && line) {
        await setLineQuantity(line, reward.variantId, 0);
        cart = await getCart();
        changed = true;
      } else if (qualifies && line && line.quantity !== 1) {
        await setLineQuantity(line, reward.variantId, 1);
        cart = await getCart();
        changed = true;
      }
    }

    // Retired-ladder cleanup: an existing/test cart may still carry a
    // Haarband or Hyaluronzuur Serum gift line added under the old ladder.
    // Those tiers no longer exist above, so remove them unconditionally.
    for (var d = 0; d < DEPRECATED_GIFT_VARIANT_IDS.length; d++) {
      var depId = DEPRECATED_GIFT_VARIANT_IDS[d];
      var depLine = findGiftLine(cart, depId);
      if (depLine) {
        await setLineQuantity(depLine, depId, 0);
        cart = await getCart();
        changed = true;
      }
    }

    // Our own /cart/add.js and /cart/change.js calls above are raw fetches,
    // not the theme's <add-to-cart>/<cart-items> elements — so nothing has
    // refreshed the visible line-item list yet. Without this, a gift the
    // engine just added/removed stays invisible until the customer's next
    // native click happens to re-render the section.
    if (changed) {
      await refreshCartSections();
    }

    updateUI(cart, qualifyingValue(cart));
  }

  // ---------------------------------------------------------------------
  // Re-render the actual cart-item-list sections after our own mutations,
  // reusing this theme's own section ids/selectors (assets/cart.js
  // getSectionsToRender) so the visible cart matches the true cart state.
  // ---------------------------------------------------------------------
  function sectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function patchElementById(id, html, selector) {
    if (!html) return;
    var el = document.getElementById(id);
    if (!el) return;
    el.innerHTML = sectionInnerHTML(html, selector);
  }

  function patchContainerContents(container, html, selector) {
    if (!html || !container) return;
    var target = container.querySelector(selector) || container;
    target.innerHTML = sectionInnerHTML(html, selector);
  }

  async function refreshCartSections() {
    var sectionIds = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];
    var mainItemsEl = document.getElementById('main-cart-items');
    var mainFooterEl = document.getElementById('main-cart-footer');
    if (mainItemsEl && mainItemsEl.dataset.id) sectionIds.push(mainItemsEl.dataset.id);
    if (mainFooterEl && mainFooterEl.dataset.id) sectionIds.push(mainFooterEl.dataset.id);

    var data;
    try {
      data = await fetch('/?sections=' + sectionIds.join(',')).then(function (r) { return r.json(); });
    } catch (err) {
      console.error('[SK Rewards] section refresh failed', err);
      return;
    }

    var miniCartHTML = data['mini-cart'];
    if (miniCartHTML) {
      var patched = false;
      if (window.theme && typeof theme.patchMiniCart === 'function') {
        patched = theme.patchMiniCart(miniCartHTML);
      }
      if (!patched) {
        patchElementById('mini-cart', miniCartHTML, '.shopify-section');
      }
    }

    patchElementById('cart-icon-bubble', data['cart-icon-bubble'], '.shopify-section');
    patchElementById('mobile-cart-icon-bubble', data['mobile-cart-icon-bubble'], '.shopify-section');

    if (mainItemsEl && mainItemsEl.dataset.id) {
      patchContainerContents(mainItemsEl, data[mainItemsEl.dataset.id], '.js-contents');
    }
    if (mainFooterEl && mainFooterEl.dataset.id) {
      patchContainerContents(mainFooterEl, data[mainFooterEl.dataset.id], '.js-contents');
    }
  }

  // ---------------------------------------------------------------------
  // UI — fully JS-driven. The Liquid snippet only provides an empty
  // container; every number, label and unlocked state is computed here
  // from the same REWARDS array used for the cart logic above.
  // ---------------------------------------------------------------------
  function getMessage(qualifying) {
    if (qualifying < 3500) {
      return {
        html: 'Nog <strong>' + money(3500 - qualifying) + '</strong> voor <strong>GRATIS verzending</strong>',
        done: false
      };
    }
    if (qualifying < 4500) {
      return {
        html: '<span class="sk-reward-progress__earned">GRATIS verzending verdiend ✓</span>' +
          'Nog <strong>' + money(4500 - qualifying) + '</strong> voor een <strong>GRATIS SPF Cream</strong> t.w.v. ' + money(1695),
        done: false
      };
    }
    if (qualifying < 7500) {
      return {
        html: '<span class="sk-reward-progress__earned">GRATIS SPF Cream verdiend ✓</span>' +
          'Nog <strong>' + money(7500 - qualifying) + '</strong> voor een <strong>GRATIS Premium Make-up Bag</strong> t.w.v. ' + money(2995),
        done: false
      };
    }
    if (qualifying < 10000) {
      return {
        html: '<span class="sk-reward-progress__earned">Premium Make-up Bag verdiend ✓</span>' +
          'Nog <strong>' + money(10000 - qualifying) + '</strong> voor een <strong>GRATIS 3D Gezichtsroller</strong> t.w.v. ' + money(1895),
        done: false
      };
    }
    return { html: 'Alle cadeaus zijn verdiend! 🎉', done: true };
  }

  function renderMilestones(container, qualifying) {
    var wrap = container.querySelector('[data-sk-reward-milestones]');
    if (!wrap) return;
    wrap.innerHTML = REWARDS.map(function (r) {
      var unlocked = qualifying >= r.threshold;
      return (
        '<div class="sk-reward-progress__milestone' + (unlocked ? ' is-unlocked' : '') + '">' +
          '<span class="sk-reward-progress__amount">' + moneyRound(r.threshold) + '</span>' +
          '<span class="sk-reward-progress__dot">' + (unlocked ? '✓' : '') + '</span>' +
          '<span class="sk-reward-progress__label">' + r.shortLabel + '</span>' +
        '</div>'
      );
    }).join('');
  }

  function updateUI(cart, qualifying) {
    var pct = Math.min(100, (qualifying / MAX_THRESHOLD) * 100);
    var containers = document.querySelectorAll('[data-sk-reward-progress]');
    containers.forEach(function (container) {
      container.hidden = cart.item_count === 0;
      if (cart.item_count === 0) return;

      var fill = container.querySelector('[data-sk-reward-fill]');
      if (fill) fill.style.width = pct + '%';

      var msg = container.querySelector('[data-sk-reward-message]');
      var result = getMessage(qualifying);
      if (msg) {
        msg.innerHTML = result.html;
        container.classList.toggle('is-complete', result.done);
      }

      renderMilestones(container, qualifying);
    });
  }

  // ---------------------------------------------------------------------
  // Event wiring — native theme events only. No global fetch/XHR patch:
  // this theme's cart.js already dispatches 'cart:updated' after every
  // quantity change, removal and discount-code change, and dispatches
  // 'ajaxProduct:added' after every drawer add-to-cart. Together with the
  // drawer's own 'cartdrawer:opened' event and one run on script load
  // (which also covers the cart page and the non-drawer full-reload
  // add-to-cart fallback), every case in the spec is covered natively.
  // ---------------------------------------------------------------------
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('ajaxProduct:added', schedule);
  document.addEventListener('cartdrawer:opened', schedule);

  schedule();
})();
